import { render, staticRenderFns } from "./ot-radio-group.vue?vue&type=template&id=6234b456&scoped=true&"
import script from "./ot-radio-group.vue?vue&type=script&lang=ts&"
export * from "./ot-radio-group.vue?vue&type=script&lang=ts&"
import style0 from "./ot-radio-group.vue?vue&type=style&index=0&id=6234b456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6234b456",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
